import { render, staticRenderFns } from "./JournalButton.vue?vue&type=template&id=33f6aa0b"
import script from "./JournalButton.vue?vue&type=script&lang=js"
export * from "./JournalButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports